// extracted by mini-css-extract-plugin
module.exports = {"primary":"#9c0","secondary":"#c5e388","primary_darken50":"#4c6600"};